import { Typography } from '@neo4j-ndl/react';
import type { ReactNode } from 'react';

type CardProps = {
  icon: ReactNode;
  title: string;
  description: string;
  actions: ReactNode;
};

export const Card = ({ icon, title, description, actions }: CardProps) => {
  return (
    <div className="border-neutral-border-weak bg-neutral-bg-weak flex min-h-40 flex-col justify-between gap-8 rounded-3xl border p-4">
      <div className="flex flex-col gap-2">
        <div className="flex flex-wrap items-center gap-2">
          {icon}
          <Typography variant="subheading-medium" className="text-neutral-text-default">
            {title}
          </Typography>
        </div>
        <Typography variant="body-medium" className="text-neutral-text-weak">
          {description}
        </Typography>
      </div>
      <Typography variant="body-medium" className="flex flex-wrap items-center gap-2">
        {actions}
      </Typography>
    </div>
  );
};
